import React, { useContext, useEffect, useState } from "react";
import {
  cardioGoalsOptions,
  neuroGoalsOptions,
  orthoGoalsOptions,
  physioDiagnosisOptions,
  sportsGoalsOptions,
} from "../../Options/physioOptions";
import { Checkbox, Form } from "antd";
import { PhysioInitialContext } from "../../Physiotherapist/PhysiotherapistInitialInspection/PhysiotherapistInitialAssessmentProvider";
import { getInitialValuesForChild } from "../../../../helpers/getInitialValues";
import DynamicInputFields from "../../../../blocks/FormItems/DynamicInputFields";

const PhysioTherapeuticGoals = ({ form }) => {
  const { formData } = useContext(PhysioInitialContext);
  const [checkboxes, setCheckboxes] = useState({});
  const [showOthers, setShowOthers] = useState({});

  const handleCheckboxChange = (value) => {
    setCheckboxes((prev) => ({
      ...prev,
      [value]: !prev[value],
    }));
  };

  const handleSubCheckboxChange = (values, mainCategory) => {
    const hasOthers = values.includes("others");
    setShowOthers((prev) => ({
      ...prev,
      [mainCategory]: hasOthers,
    }));
  };

  const getOptions = (value) => {
    switch (value) {
      case "cardio":
        return cardioGoalsOptions;
      case "ortho":
        return orthoGoalsOptions;
      case "sports":
        return sportsGoalsOptions;
      case "neuro":
        return neuroGoalsOptions;
      default:
        return [];
    }
  };

  useEffect(() => {
    form.setFieldsValue(formData?.therapeutic_goals);
  }, [formData]);

  useEffect(() => {
    const initialCheckboxes = physioDiagnosisOptions.reduce((acc, checkbox) => {
      acc[checkbox.value] =
        getInitialValuesForChild(
          physioDiagnosisOptions,
          formData?.therapeutic_goals !== null && formData?.therapeutic_goals
        )[checkbox.value] || false; // Initialize all checkboxes based on formData
      return acc;
    }, {});
    setCheckboxes(initialCheckboxes);

    // Initialize showOthers only when others has real (non-empty) remarks
    const hasOthersContent = (others) =>
      Array.isArray(others) &&
      others.some((item) => {
        const remarks = item?.remarks ?? item;
        return typeof remarks === "string"
          ? remarks.trim() !== ""
          : remarks != null && remarks !== "";
      });

    const initialShowOthers = physioDiagnosisOptions.reduce((acc, checkbox) => {
      const others =
        formData?.therapeutic_goals?.[`${checkbox.value}_others`];
      const details =
        formData?.therapeutic_goals?.[`${checkbox.value}_details`] || [];
      acc[checkbox.value] =
        (Array.isArray(details) && details.includes("others")) ||
        hasOthersContent(others);
      return acc;
    }, {});
    setShowOthers(initialShowOthers);
  }, [formData]);

  return (
    <>
      {physioDiagnosisOptions?.map((option) => (
        <div key={option.value}>
          <Form.Item name={option.value} valuePropName="checked">
            <Checkbox
              onChange={() => handleCheckboxChange(option.value)}
              checked={checkboxes[option.value]}
            >
              {option.label}
            </Checkbox>
          </Form.Item>
          {checkboxes[option?.value] && option?.value === "others" ? (
            <>
              <DynamicInputFields
                field_key={"others"}
                form={form}
                inputStyle={{ maxWidth: 800 }}
              />
            </>
          ) : (
            checkboxes[option.value] && (
              <div className="subsection-card">
                <Form.Item
                  name={`${option.value}_details`}
                  // valuePropName="checked"
                >
                  <Checkbox.Group
                    // options={getOptions(option.value)}
                    onChange={(values) =>
                      handleSubCheckboxChange(values, option.value)
                    }
                    value={
                      formData?.therapeutic_goals?.[
                        `${option.value}_details`
                      ] || []
                    }
                  >
                    {getOptions(option.value).map((subOption) => (
                      <div
                        key={subOption.value}
                        className="therapeutic-goal-option"
                        style={{
                          maxWidth: "100%",
                          width: "100%",
                          padding: "6px 0",
                          boxSizing: "border-box",
                        }}
                      >
                        <Checkbox value={subOption.value}>
                          {subOption.label}
                        </Checkbox>
                      </div>
                    ))}
                  </Checkbox.Group>
                </Form.Item>
                {showOthers[option.value] && (
                  <DynamicInputFields
                    field_key={`${option.value}_others`}
                    form={form}
                    inputStyle={{ maxWidth: 800 }}
                  />
                )}
              </div>
            )
          )}
        </div>
      ))}
    </>
  );
};

export default PhysioTherapeuticGoals;
